export const regex = /[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/g;
